import {
  GET_LOG_REQUEST,
  GET_LOG_SUCCESS,
  GET_LOG_FAILURE,
  GET_LOG_DETAIL_REQUEST,
  GET_LOG_DETAIL_SUCCESS,
  GET_LOG_DETAIL_FAILURE
} from "src/actions/logAction";
import produce from "immer";

const initialState = {
  logs: [],
  log: {},
  total: 0,
  loadingGetLogs: false,
  loadingGetLog: false
  // platform: {},
  // loadingGetPlatforms: false,
  // loadingCreatePlatform: false,
  // loadingGetOnePlatform: false,
  // loadingUpdatePlatform: false,
  // loadingUpdatePermissionOfPlatform: false,
  // loadingUpdateActivePlatform: false
};

const logReducer = (state = initialState, action) => {
  switch (action.type) {
    // Case Get Audit Log
    case GET_LOG_REQUEST: {
      return produce(state, (draft) => {
        draft.logs = [];
        draft.loadingGetLogs = true;
      });
    }

    case GET_LOG_SUCCESS: {
      const {response, total} = action.payload;
      return produce(state, (draft) => {
        draft.logs = response;
        draft.total = total;
        draft.loadingGetLogs = false;
      });
    }

    case GET_LOG_FAILURE: {
      return produce(state, (draft) => {
        // Maybe Audit Log  failure
        draft.loadingGetLogs = false;
      });
    }

    case GET_LOG_DETAIL_REQUEST: {
      return produce(state, (draft) => {
        draft.item = {};
        draft.loadingGetLog = true;
      });
    }

    case GET_LOG_DETAIL_SUCCESS: {
      const {response} = action.payload;
      return produce(state, (draft) => {
        draft.log = response;
        draft.loadingGetLog = false;
      });
    }

    case GET_LOG_DETAIL_FAILURE: {
      return produce(state, (draft) => {
        draft.loadingGetLog = false;
      });
    }

    default: {
      return state; // We return the default state here
    }
  }
};

export default logReducer;
